import { Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { RadioButtonComponent } from "../../../design-system/radio-button/radio-button.component";
import { RadioItem, RadioConfig } from "../../../design-system/radio-button/radio.modal";
@Component({
  selector: 'radio-renderer',
  templateUrl: './radio-renderer.component.html',
  standalone: true,
  imports: [TranslateModule, RadioButtonComponent]
})
export class RadioRendererComponent implements ICellRendererAngularComp {
  isSelected: boolean;
  isCheckboxDisabled: boolean;
  params: any;
  isHideText: boolean;
  radioItem: RadioItem = {
    disabled: false,
    label: '',
    checked: false,
    secondaryText: '',
    anchorText: '',
    link: ''
  };
  radioConfig: RadioConfig = {};
  constructor() {
  }

  initilize(params: ICellRendererParams) {
    if (params.data) {
      this.params = params;
      this.isSelected = params.data.selected;

      if (params.data.isHideText) {
        this.isHideText = params.data.isHideText;
      }
      this.radioItem = {
        ...this.radioItem,
        checked: this.isSelected,
        label: params.data.label ? params.data.label : '',
      }
      this.radioConfig = {
        ...this.radioConfig,
        options: [this.radioItem]
      }
    }

    //delete after testing
    this.radioItem = {
      ...this.radioItem,
      checked: true,
    }
    this.radioConfig = {
      ...this.radioConfig,
      options: [this.radioItem]
    }
    this.isHideText = false;
  }

  onClick(event) {
    if (this.params.onClick instanceof Function) {
      let params = { event: event, rowData: this.params.node.data }
      this.params.onClick(params);
    }
  }

  // called on init
  agInit(params: any): void {
    this.initilize(params);
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}




